// extracted by mini-css-extract-plugin
export default {"urgent":"urgent_urgent__hMM9Q","urgent__link":"urgent_urgent__link__XGG67"};